import { useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import AuthLayout from "./AuthLayout";
import Field from "./components/Field";
import Button from "./components/Button";
import Stack from "./components/Stack";
import { adminLogin } from "./api";

export default function AdminLogin() {
  const history = useHistory();
  const [uname, setuname] = useState("");
  const [pwd, setpwd] = useState("");
  localStorage.setItem("adminlogged", "invisible");

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await adminLogin(uname, pwd);
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("adminlogged", "visible");
      toast.success("Login successful!");
      history.push("/adminpanel");
    } catch (error) {
      toast.error("Login unsuccessful. Try again.");
    }
  };

  return (
    <AuthLayout title="Admin login" subtitle="Manage users and comments.">
      <form onSubmit={onSubmit}>
        <Stack gap="5">
          <Field id="uname" label="Username" value={uname}
                 onChange={(e) => setuname(e.target.value)} autoComplete="username" required />
          <Field id="pwd" label="Password" type="password" value={pwd}
                 onChange={(e) => setpwd(e.target.value)} autoComplete="current-password" required />
          <Button type="submit">Log in</Button>
        </Stack>
      </form>
    </AuthLayout>
  );
}
